import React from 'react';
import Image from 'next/image';

interface TossIconProps {
  className?: string;
  size?: number;
}

export const TossIcon: React.FC<TossIconProps> = ({ className = "", size = 24 }) => {
  return (
    <Image
      src="/icons/toss-app-icon-100px.png"
      alt="Toss"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default TossIcon;